export default "__VITE_ASSET__b47d6eae__"